import { EcommerceSubCategoryModel } from '@/helpers/entities/models/EcommerceSubCategoryModel';
export class EcommerceProductCategoryModel {
    constructor(category) {
        const { baseGlobalId, uuid, name, description, productSubcategories } = category;
        this.baseGlobalId = baseGlobalId;
        this.uuid = uuid;
        this.name = name;
        this.description = description;
        this.subcategories = [];
        const subcategory = (sc) => {
            return new EcommerceSubCategoryModel(sc.node);
        };
        if (productSubcategories) {
            this.subcategories = productSubcategories.edges.map(subcategory);
        }
    }
    get subCategoryUuids() {
        return this.subcategories.map((sub) => {
            return sub.uuid;
        });
    }
}
